<template>
  <div>
    <div>
      <h2>{{name}}</h2>

      <div v-if="matches.length">
        <relative-match
          v-for="relMatch in matches"
          :key="relMatch.key"
          :relativeMatch="relMatch">
        </relative-match>
      </div>
      <div v-else>
        No matches found
      </div>
    </div>
  </div>
</template>
<script>
import  RelativeMatch  from '@/components/cricket/RelativeMatch'

export default {
  components : {
    'RelativeMatch': RelativeMatch
  },
  props: {
    teamKey: String,
    name: String,
    matches: Array
  },

  data () {
    return {
    }
  },

  mounted () {
  }
}
</script>
